var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 80,
    viewBox: "0 0 216 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.78 38H60.8 53.78c-.777-3.45-3.517-6-6.779-6H22c-3.866 0-7-3.582-7-8s3.134-8 7-8h40c-3.866 0-7-3.582-7-8s3.134-8 7-8h57c3.866 0 7 3.582 7 8 0 .339-.018.672-.054 1H71a4 4 0 0 0-4 4v55a4 4 0 0 0 4 4h85a4 4 0 0 0 4-4V16h23c3.866 0 7 3.582 7 8s-3.134 8-7 8h22c3.866 0 7 3.582 7 8s-3.134 8-7 8h-19c-3.866 0-7 3.582-7 8s3.134 8 7 8h6c3.866 0 7 3.582 7 8s-3.134 8-7 8H46c-3.866 0-7-3.582-7-8s3.134-8 7-8H7c-3.866 0-7-3.582-7-8s3.134-8 7-8h40c3.866 0 7-3.582 7-8a9.1 9.1 0 0 0-.22-2Zm7.02-16H49h11.8Zm-27.2 8h27.201-27.2Z",
    fillOpacity: 0.3,
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fillOpacity: 0.3,
    fill: "#7F7F7F",
    cx: 209,
    cy: 72,
    rx: 7,
    ry: 8
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 9)",
    stroke: "#6A6666",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47.25,
    y: 1.25,
    width: 91.5,
    height: 60.5,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 2 96.447 33.952a6 6 0 0 1-7.543-.002L49.407 2H136ZM39.47 13.866H27.588h11.88Zm-27.387 8H39.47 12.083Zm-11.68 8H39.47.402Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmails);
export default __webpack_public_path__ + "static/media/emails.ceaaf20ab760e860077497f386a58f5b.svg";
export { ForwardRef as ReactComponent };